export enum RR_MODAL_BUTTON_TYPE {
  CONFIRM,
  CANCEL,
}
